import React from 'react';
import classnames from 'classnames';

export interface ListItemMetaProps {
  className?: string;
  tabIndex?: number;
  meta: string | React.ReactElement<any>;
  childrenTabIndex?: number;
}

const ListItemMeta: React.FunctionComponent<ListItemMetaProps> = ({
  tabIndex,
  meta,
  className = '',
  ...otherProps
}) => {
  let metaElement: React.ReactElement<any>;
  if (typeof meta === 'string') {
    metaElement = <span>{meta}</span>;
  } else {
    metaElement = meta;
  }
  const metaProps = {
    className: classnames(
      'mdc-list-item__meta',
      className,
      metaElement.props.className
    ),
    tabIndex: tabIndex !== undefined ? tabIndex : -1,
    ...otherProps,
  };
  return React.cloneElement(metaElement, metaProps);
};

export default ListItemMeta;
